<template>
  <Accordion id="asta-filter-accordion" class="asta-filter-accordion" v-model="openPanels"
    @update:modelValue="setOpenPanels($event)" :buttons="[
      { desktopLabel: store.texter.searchresultblock.FilterButtonLabel, mobileLabel: store.texter.searchresultblock.filter, group: 'filter' },
      {
        desktopLabel: store.texter.searchresultblock.SortLabel,
        mobileLabel: store.texter.searchresultblock.SortLabel,
        group: 'sort',
        class: 'mobileOnly',
      },
    ]">
    <template #content>
      <AccordionContent group="filter" class="asta-filter" :open="true">
        <div class="SearchFilter col-sm-12">
          <div class="row">
            <div class="Heading col-sm-12">
              <strong>{{ store.texter.searchresultblock.filter }}</strong>
            </div>
            <RadioRow name="Utbildningstyp" label="Program eller kurs" v-model="store.filter.utbildningstyp!"
              class="col-sm-7" @update:modelValue="setFilterAndEmit({ utbildningstyp: $event })" :options="[
                { label: 'Båda', value: null! },
                { label: 'Program', value: 'program' },
                { label: 'Kurs', value: 'kurs' },
              ]" />
            <MultiDropDown name="larosaten_xx" label="Universitet/högskolor" v-model="valdaLarosaten"
              :options="larosaten" @update:modelValue="setFilterAndEmit({ larosaten: [...$event] })" :delayUpdate="true"
              :autoSize="true" :formatSelected="formatSelectedLarosaten" class="col-sm-5 larosaten">
              <template #firstItem>
                <li role="option" class="list-option">
                  <input type="checkbox" id="larosate_notSelected" value="" :checked="valdaLarosaten.length == 0"
                    @change="clearSelectedLarosaten($event as InputEvent)" />
                  <label tabindex="-1" for="larosate_notSelected" class="container-choice">
                    <Svgicon iconName="check" aria-hidden="true" focusable="false" />
                    <span class="txt">{{ store.texter.searchresultblock.allunis }}</span>
                  </label>
                </li>
              </template>
            </MultiDropDown>
          </div>
        </div>
        <div class="SearchVisningsalternativ col-sm-12">
          <div class="row">
            <div class="Heading col-sm-12">
              <strong>{{ store.texter.searchresultblock.displayoptions }}</strong>
            </div>
            <RadioRow name="AntagnaSokande" label="Antagna eller sökande" v-model="store.display.vygroup"
              class="col-sm-6 col-md-4" @update:modelValue="setDisplayAndEmit({ vygroup: $event })" :options="[
                { label: 'Antagna', value: 'antagna' },
                { label: 'Sökande', value: 'sokande' },
              ]" />
            <DropDown :label="store.texter.searchresultblock.displayoptions" class="col-sm-6 col-md-4"
              :options="visningsalternativ" v-model="store.display.vy"
              @update:modelValue="setDisplayAndEmit({ vy: $event })" />
            <MultiDropDown name="urvalsgrupp_xx" label="Urvalsgrupp" v-if="store.display.vygroup === 'antagna'"
              v-model="valdaUrvalsgrupper" :formatSelected="formatSelectedUrval" :options="allaUrvalsgrupper"
              @update:modelValue="setDisplayAndEmit({ urvalsgrupper: [...$event] })" class="col-sm-12 col-md-4">
              <template #firstItem>
                <li role="option" class="list-option">
                  <input type="checkbox" id="urvalsgrupp_notSelected" value=""
                    :checked="valdaUrvalsgrupper?.length === 0" @change="setDisplayAndEmit({ urvalsgrupper: [] })" />
                  <label tabindex="-1" for="urvalsgrupp_notSelected" class="container-choice">
                    <Svgicon iconName="check" aria-hidden="true" focusable="false" />
                    <span class="txt">{{ store.texter.searchresultblock.showallselectiongroups }}</span>
                  </label>
                </li>
              </template>
            </MultiDropDown>
          </div>
        </div>
      </AccordionContent>
      <AccordionContent group="sort" class="asta-filter" :open="false">
        <MobilSortering></MobilSortering>
      </AccordionContent>
    </template>
  </Accordion>
  <InfoView :promptText="promptText" :text="store.infoText" class="mobil" />
</template>
<script setup lang="ts">
import { computed, ref } from 'vue';
import type { AstaDisplaySettings, AstaFilterSettings } from '../../types/AstaTypes';
import useAstaStore from '../stores/AstaStore';
import Accordion from '../components/Accordion/Accordion.vue';
import AccordionContent from '../components/Accordion/AccordionContent.vue';
import DropDown from '../components/DropDown.vue';
import MultiDropDown from '../components/MultiDropDown.vue';
import RadioRow from '../components/RadioRow.vue';
import Svgicon from '../components/svgicon.vue';
import InfoView from './InfoView.vue';
import MobilSortering from './MobilSortering.vue';

const store = useAstaStore();
const promptText = ref(Asta.Texter.PromtText);

const valdaLarosaten = ref<string[]>([]);
const valdaUrvalsgrupper = ref<string[]>([...store.defaultUrvalsgrupper]);
const openPanels = ref<string[]>(['filter']);
const setOpenPanels = (panels: string[]) => {
  console.log('setOpenPanels', panels);
  openPanels.value = panels;
};

const emit = defineEmits<{
  (event: 'displayChange', settings: AstaDisplaySettings): void;
  (event: 'filterChange', settings: AstaFilterSettings): void;
}>();

const formatSelectedLarosaten = (_value: string[]) => {
  //Visar valda o inte dom man kryssat i..
  var val = [...(store.filter.larosaten ?? [])];
  if (val.length === 0) {
    return store.texter.searchresultblock.allunis;
  }
  return val.join(', ');
};

const formatSelectedUrval = (value: string[]) => {
  if (value.length === 0) {
    return store.texter.searchresultblock.showallselectiongroups;
  }
  return value.join(', ');
};

const clearSelectedLarosaten = (e: InputEvent) => {
  const v = (e.target as HTMLInputElement).checked;
  console.log('clearSelectedLarosaten', v, valdaLarosaten.value);
  if (v) {
    while (valdaLarosaten.value.length > 0) {
      valdaLarosaten.value.pop();
    }
  }
};
const allaUrvalsgrupper = computed(() => {
  const valuesToSortInOrder = ['BI', 'BII', 'BF', 'HP', 'AU', 'SA', 'ÖS'];
  var tmp = store.allaUrvalsgrupper.map((o) => o.urvalsgruppId);

  const getLabel = (value: string) => {
    let v = value;
    const t = store.texter.searchresultblock.selecttiongroup as { [key: string]: any };
    if (t[value]) {
      v += ' <span class="urvalsgruppInfo">' + (t[value]?.fullline ?? t[value]) + '</span>';
    }
    return v;
  };

  tmp.sort((a, b) => {
    const ai = valuesToSortInOrder.indexOf(a.toUpperCase()),
      bi = valuesToSortInOrder.indexOf(b.toUpperCase());
    if (ai == -1 && bi == -1) return 0;
    if (ai == -1) return 1;
    if (bi == -1) return -1;
    return ai - bi;
  });
  return tmp.map((o) => ({ label: getLabel(o), value: o }));
});

const visningsalternativ = computed(() => {
  return store.display.vygroup == 'antagna' ? store.visningsalternativAntagna : store.visningsalternativSokande;
});
const larosaten = computed(() => store.allaLarosaten?.map((o) => ({ label: o.lärosäte, value: o.lärosäteId })));

const setDisplayAndEmit = (args: any) => {
  const d = { ...store.display, ...args } as AstaDisplaySettings;
  valdaUrvalsgrupper.value = d.urvalsgrupper ?? [];
  store.setDisplay(d);
  emit('displayChange', d);
};

const setFilterAndEmit = (args: any) => {
  console.log('setFilterAndEmit', args);
  const f = { ...store.filter, ...args } as AstaFilterSettings;
  while (valdaLarosaten.value.length > 0) {
    valdaLarosaten.value.pop();
  }
  if (f.larosaten) {
    f.larosaten.forEach((l) => valdaLarosaten.value.push(l));
  }
  store.setFilter(f);
  emit('filterChange', f);
};
</script>
